import AdminBar from '../components/sections/AdminBar/AdminBar';
import Navbar from '../components/sections/Navbar/Navbar';
import Promo from '../components/sections/Promo/Promo';
import Footer from '../components/sections/Footer/Footer';
import './LandingLayout.css';

export default function LandingLayout(content, conference = {}) {
    return `
		${AdminBar()}
        ${Navbar(conference)}
        
        <main class="landing-layout">
            ${content}
        </main>
        
        ${Footer()}
    `;
}
